module.exports = __webpack_public_path__ + "img/c4.2b72f3b7.jpg";